<template>
    <div class="account-header mgl" data-show="#acc-pane">
        <a href="javascript:;" :title="user.name" class="avt" @click="showNotification">
            <img onerror="this.src='/default-avatar.jpg'" :src="user.avatar" alt="">
            <span v-if="!this.iconNotification && this.count > 0">{{ count }}</span>
        </a>
        <div class="pane" id="acc-pane">
            <div class="list-notification">
                <div v-for="(noti, index) in notification" :key="index" v-html="noti.message" @click="checkWatched(noti.id, index)"></div>
            </div>
            <a href="javascript:;" v-if="notification.length >= 3" title="Xem thêm" class="view-more" @click="redirectViewMore">Xem thêm...</a>
            <ul>
                <li>
                    <a class="display-table" tabindex="-1" title="" role="menuitem" data-toggle="modal" data-target="#modalInfo"><i class="fas fa-user"></i> Thông tin cá nhân</a>
                </li>
                <li>
                    <a class="smooth" href="javascript:;" @click="redirectTo(urlLogout)" title=""><i class="fas fa-sign-out"></i> Đăng xuất</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        props: [
            'urlLogout'
        ],
        components: {
            InfiniteLoading
        },
        data() {
            return {
                notification: [],
                page: 2,
                isInit: true,
                interlet:null,
                notificationShow:false,
                iconNotification:false,
                count: 0,
                loadding: false,
            }
        },
        created() {
            this.fetchNotification()
                .then(response => {
                    let _that = this;
                    if(response.data.status == 200) {
                        if(response.data.data.data.length > 0) {
                            _that.notification = response.data.data.data;
                        } else {}
                    }
                })
                .catch(e => console.log(e));
            this.getCountNotification();
        },
        mounted() {
            let _that = this;
            $(window).focus(function() {
            if (!this.intervar)
                this.intervar = setInterval(() => {
                _that.iconNotification = false;
                _that.isInit= true;
                _that.getCountNotification();
                // Chỉ được gọi thằng số 30s 1 lần
                // _that.fetchNotification()
                // .then(response => {
                //     if(response.data.status == 200) {
                //         if(response.data.data.data.length > 0) {
                //             _that.notification = response.data.data.data;
                //             _that.page = 2;
                //             _that.isInit = false;
                //         } else {}
                //     }
                // })
                // .catch(e => console.log(e));
                    _that.isInit = false;
                }, 300000);
            });

            $(window).blur(function() {
                clearInterval(this.intervar);
                this.intervar = 0;
            });
        },
        methods: {
            onClickOutside(event) {
                this.notificationShow = false;
            },
            checkWatched(id, index) {
                let url = '/update-watch-notification/'+ id
                axios({
                    method: 'post',
                    url: url,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {})
                .catch(error => {})
            },
            getCountNotification () {
                axios.get('/get-count-notification')
                .then(response => {
                    this.count = response.data.data.count;
                })
                .catch(error => {

                })
            },
            showNotification() {
                this.notificationShow = !this.notificationShow;
                this.iconNotification = true;
                //Thay vì gọi 30s 1 lần thì ấn show chuông sẽ gọi lại
                this.isInit= true;
                this.fetchNotification()
                .then(response => {
                    if(response.data.status == 200) {
                        if(response.data.data.data.length > 0) {
                            this.notification = response.data.data.data;
                            this.page = 2;
                            this.isInit = false;
                        } else {}
                    }
                })
                .catch(e => console.log(e));

                this.isInit = false;
                axios.get('/update-notification')
                    .then(response => {})
                    .catch(error => {})
            },
            fetchNotification() {
                let url = this.isInit
                        ? axios.get('/get-notification')
                        : axios.get('/get-notification?page=' + this.page);
                return url;
            },
            redirectViewMore() {
                window.location.href = "/thongbao";
            },

            redirectTo(url) {
                window.location.href = url;
            }
        },
        beforeDestroy(){
            clearInterval(this.interval);
        }
    }
</script>
<style lang="scss">
    .avt {
        img {
            width: 40px;
            height: 40px;
        }
    }
    .show {
        display: block !important;
    }
</style>